import { ApiError } from "@gjwtrack/client";
import { useState, type FormEvent } from "react";
import { useLocation, useNavigate } from "react-router";
import { client } from "../lib/client.ts";
import { Button, Input, InputSize } from "../ui/ring.ts";

export function LoginPage({ onLoggedIn }: { onLoggedIn: () => void }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const from = (location.state as { from?: string } | null)?.from ?? "/issues";

  const submit = async (e: FormEvent): Promise<void> => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    try {
      await client.http.login(email, password);
      await client.start();
      onLoggedIn();
      navigate(from, { replace: true });
    } catch (err) {
      setError(err instanceof ApiError && err.status === 401 ? "Wrong email or password." : (err as Error).message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="flex h-full items-center justify-center p-6">
      <form onSubmit={(e) => void submit(e)} className="flex w-80 flex-col gap-3 rounded border border-line bg-surface p-6 shadow-sm">
        <h1 className="text-lg font-semibold tracking-tight">GJWTrack</h1>
        <p className="mb-2 text-muted">Sign in to continue.</p>
        <Input label="Email" size={InputSize.FULL} type="email" autoComplete="username" autoFocus value={email} onChange={(e) => setEmail(e.target.value)} required />
        <Input label="Password" size={InputSize.FULL} type="password" autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} required />
        {error && <div className="rounded bg-danger-soft px-2 py-1 text-danger">{error}</div>}
        <Button primary type="submit" className="mt-1 w-full" disabled={busy}>
          {busy ? "Signing in…" : "Sign in"}
        </Button>
      </form>
    </div>
  );
}
